<div class="row" id="actions-container">
    <div class="col-12 mb-3">
        <button (click)="goBack()" class="btn btn-outline-secondary"><i class="fas fa-arrow-left"></i> Back to Dashboard</button>
    </div>
    <div class="col-12">
        <h2 class="mb-3">Account Statement</h2>
    </div>
    <div class="col-12 col-md-8">
        <div class="row">
            <div class="col-md-5">
                <label for="fromDate" class="form-label">From Date</label>
                <input type="date" class="form-control" id="fromDate" [(ngModel)]="fromDate" (change)="onDateChange()" />
            </div>
            <div class="col-md-5">
                <label for="toDate" class="form-label">To Date</label>
                <input type="date" class="form-control" id="toDate" [(ngModel)]="toDate" (change)="onDateChange()" />
            </div>
            <div class="col-md-2 d-flex align-items-end">
                <button (click)="loadPayouts()" class="btn btn-info text-white w-100" type="button">
                    <i class="fas fa-refresh"></i>
                </button>
            </div>
        </div>
    </div>
    <div class="col-12 col-md-4 d-flex align-items-end justify-content-end">
        <button (click)="printPage()" class="print-button btn btn-md btn-secondary text-white" type="button">
            <i class="fa-solid fa-print"></i>
            Print
        </button>
    </div>
</div>

<div id="outer-container" *ngIf="!loading">
    <div id="print-container">
        <div class="row">
            <div class="row mb-4">
                <div class="col-6">
                    <h2 class="mb-3">Account Statement</h2>
                    <div class="statement-period"><strong>Period:</strong> {{ fromDate | date: 'dd MMM yyyy' }} to {{ toDate | date: 'dd MMM yyyy' }}</div>
                    <div *ngIf="merchant" class="mt-2">
                        <div><strong>Company:</strong> {{ merchant.companyName }}</div>
                        <div *ngIf="merchant.companyRegistration"><strong>Registration:</strong> {{ merchant.companyRegistration }}</div>
                        <div *ngIf="merchant.vatNumber"><strong>VAT Number:</strong> {{ merchant.vatNumber }}</div>
                        <div *ngIf="merchant.phone"><strong>Phone:</strong> {{ merchant.phone.internationalNumber }}</div>
                    </div>
                </div>
                <div class="col-6 text-end">
                    <img class="logo-image" crossorigin="*" src="/assets/images/home/logo-blue-250.png" />
                    <div class="company-info">Registered Name: The Upps (Pty) Ltd</div>
                    <div class="company-info">Registration Number: 2022/433971/07</div>
                    <div class="company-info">VAT number: 4620313298</div>
                    <div class="company-info">32 Kloof St, Gardens, Cape Town, 8001, South Africa</div>
                </div>
            </div>
        </div>

        <br />

        <!-- Summary Cards -->
        <div class="summary-section">
            <div class="row mb-4">
                <div class="col-md-4">
                    <div class="summary-card paid-card">
                        <div class="summary-label">Total Paid</div>
                        <div class="summary-amount">R{{ totalPaid | number: '1.2-2' }}</div>
                        <div class="summary-count">{{ paidPayouts.length }} proforma(s)</div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="summary-card owing-card">
                        <div class="summary-label">Total Owing</div>
                        <div class="summary-amount">R{{ totalOwing | number: '1.2-2' }}</div>
                        <div class="summary-count">{{ owingPayouts.length }} proforma(s)</div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="summary-card total-card">
                        <div class="summary-label">Grand Total</div>
                        <div class="summary-amount">R{{ grandTotal | number: '1.2-2' }}</div>
                        <div class="summary-count">{{ payouts.length }} proforma(s)</div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Paid Proforma Invoices Section -->
        <div class="row" *ngIf="paidPayouts.length > 0">
            <div class="col-12">
                <h4 class="section-heading">Paid Proforma Invoices</h4>
                <table class="table table-bordered">
                    <thead id="header-row">
                        <tr>
                            <th>Proforma #</th>
                            <th>Created Date</th>
                            <th>Payout Date</th>
                            <th class="text-end">Payout Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let payout of paidPayouts">
                            <td>PFI-{{ payout.payoutNumber }}</td>
                            <td>{{ payout.createdAt.toDate() | date: 'dd MMM yyyy' }}</td>
                            <td>{{ payout.payoutDate ? (payout.payoutDate.toDate() | date: 'dd MMM yyyy') : '-' }}</td>
                            <td class="text-end">R{{ payout.payoutAmount | number: '1.2-2' }}</td>
                        </tr>
                        <tr class="subtotal-row">
                            <td colspan="3" class="text-end"><strong>Subtotal (Paid):</strong></td>
                            <td class="text-end">
                                <strong>R{{ totalPaid | number: '1.2-2' }}</strong>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- Outstanding Proforma Invoices Section -->
        <div class="row mt-4" *ngIf="owingPayouts.length > 0">
            <div class="col-12">
                <h4 class="section-heading">Outstanding Proforma Invoices</h4>
                <table class="table table-bordered">
                    <thead id="header-row">
                        <tr>
                            <th>Proforma #</th>
                            <th>Created Date</th>
                            <th>Status</th>
                            <th class="text-end">Payout Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let payout of owingPayouts">
                            <td>PFI-{{ payout.payoutNumber }}</td>
                            <td>{{ payout.createdAt.toDate() | date: 'dd MMM yyyy' }}</td>
                            <td>
                                <span *ngIf="payout.status === PayoutStatusEnum.DUE" class="badge bg-enterprise-secondary text-white">Due</span>
                                <span *ngIf="payout.status === PayoutStatusEnum.BATCHED" class="badge bg-info text-dark">Batched</span>
                            </td>
                            <td class="text-end">R{{ payout.payoutAmount | number: '1.2-2' }}</td>
                        </tr>
                        <tr class="subtotal-row">
                            <td colspan="3" class="text-end"><strong>Subtotal (Owing):</strong></td>
                            <td class="text-end">
                                <strong>R{{ totalOwing | number: '1.2-2' }}</strong>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- Grand Total -->
        <div class="row mt-4">
            <div class="col-12">
                <table class="table">
                    <tbody>
                        <tr class="grand-total-row">
                            <td class="text-end"><h4>Statement Total:</h4></td>
                            <td class="text-end" style="width: 200px">
                                <h4>R{{ grandTotal | number: '1.2-2' }}</h4>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- No proforma invoices message -->
        <div class="row" *ngIf="payouts.length === 0">
            <div class="col-12">
                <div class="alert alert-info">No proforma invoices found for the selected period.</div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="loading" class="text-center p-5">
    <i class="fa-solid fa-circle-spinner fa-spin fa-3x"></i>
    <p class="mt-3">Loading statement...</p>
</div>
